import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider, initializeCSSVariables } from "./contexts/ThemeContext";
import ViewCdha from "./pages/ViewCDHA/ViewCdha";
import DangKyKcb from "./pages/DangKyKcb/dangKyKcb";
import HiepHoiDoanhNghiep from "./components/HiepHoiDN";
import DaiHoiCoDong from "./components/DaiHoiCoDong";
import MedicalLayout from "./components/layout/MedicalLayout/MedicalLayout";
// Trang Home cũ tạm ẩn khỏi router, code vẫn giữ ở ./pages/Home/Home để dùng lại
// import Home from "./pages/Home/Home";
import Landing from "./pages/Landing/Landing";
import "./styles/antd-overrides.css";

// Initialize CSS variables when app starts
initializeCSSVariables();

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <Switch>
          <Route path="/" exact>
            <MedicalLayout>
              <Landing />
            </MedicalLayout>
          </Route>
          <Route path="/crm" exact>
            <MedicalLayout>
              <Landing />
            </MedicalLayout>
          </Route>
          <Route path="/crm/cdha" exact>
            <MedicalLayout>
              <ViewCdha />
            </MedicalLayout>
          </Route>
          <Route path="/crm/kcb" exact>
            <MedicalLayout>
              <DangKyKcb />
            </MedicalLayout>
          </Route>
          <Route path="/crm/dai-hoi-co-dong" exact component={DaiHoiCoDong} />
          <Route
            path="/crm/hiep-hoi-doanh-nghiep"
            exact
            component={HiepHoiDoanhNghiep}
          />

          {/* Fallback route nếu không khớp */}
          <Route path="*">
            <h1 style={{ textAlign: "center", marginTop: 100 }}>
              404 - Không tìm thấy trang
            </h1>
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;
